import { render, staticRenderFns } from "./WinEval.vue?vue&type=template&id=7e199228&scoped=true"
import script from "./WinEval.vue?vue&type=script&lang=js"
export * from "./WinEval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e199228",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QInput from 'quasar/src/components/input/QInput.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QIcon,QBtn,QSeparator,QSlider,QCheckbox,QDialog,QInput});qInstall(component, 'directives', {ClosePopup});
